import React, { useEffect } from "react";

const Insta = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.setAttribute("data-use-service-core", "");
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <div
        class="elfsight-app-d8e7d855-cc01-451d-83d7-2bfcd6035330"
        data-elfsight-app-lazy
      ></div>
    </>
  );
};

export default Insta;
